import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MyProfilePage: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '80px 20px', fontFamily: "'Cairo', sans-serif", color: '#9E9E9E' }}>
        جاري التحميل...
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={'/users/' + user.id} replace />;
};

export default MyProfilePage;
